import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import {Helper} from "../../../../containers/AppPage/Reports/DepreciationSchedule/Helper";

function getColumns(props) {
    const { currency_symbol } = props;
    return [
        {
            key: 'code',
            dataKey: 'code',
            title: t`Code`,
            width: 0,
            flexGrow: 12,
            cellRenderer: Helper.renderCode,
            defaulto: true,
        },
        {
            key: 'name',
            dataKey: 'name',
            title: t`Name`,
            width: 0,
            flexGrow: 18,
            cellRenderer: Helper.renderName,
            required: true,
        },
        {
            key: 'serial_number',
            dataKey: 'serial_number',
            title: t`Serial No.`,
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderText(rowData.serial_number, rowData),
        },
        {
            key: 'purchase_date',
            dataKey: 'purchase_date',
            title: t`Purchase Date`,
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderDate(rowData.purchase_date, rowData),
            defaulto: true,
        },
        {
            key: 'purchase_price',
            dataKey: 'purchase_price',
            title: t`Purchase Price`,
            width: 0,
            flexGrow: 12,
            align: 'right',
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData, rowData.purchase_price, currency_symbol,
            ),
            defaulto: true,
        },
        {
            key: 'depreciation_start_date',
            dataKey: 'depreciation_start_date',
            title: t`Dep Start Date`,
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderDate(rowData.depreciation_start_date, rowData),
        },
        // {
        //     key: 'cost_price',
        //     dataKey: 'cost_price',
        //     title: t`Cost Price`,
        //     align: 'right',
        //     width: 0,
        //     flexGrow: 12,
        //     cellRenderer: ({rowData}) => Helper.renderAmount(
        //         rowData.cost_price, rowData.currency_symbol,
        //     ),
        //     defaulto: true,
        // },
        {
            key: 'cost_limit',
            dataKey: 'cost_limit',
            title: t`Cost Limit`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData, rowData.cost_limit, currency_symbol, true,
            ),
        },
        {
            key: 'residual_value',
            dataKey: 'residual_value',
            title: t`Residual Value`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData, rowData.residual_value, currency_symbol, true,
            ),
        },
        {
            key: 'depreciation_method',
            dataKey: 'depreciation_method',
            title: t`Dep Method`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: Helper.renderDepreciationMethod,
        },
        {
            key: 'depreciation_convention',
            dataKey: 'depreciation_convention',
            title: t`Dep Convention`,
            // align: 'left',
            width: 0,
            flexGrow: 12,
            cellRenderer: Helper.renderDepreciationConvention,
        },
        {
            key: 'depreciation_rate',
            dataKey: 'depreciation_rate',
            title: t`Dep Rate`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: Helper.renderDepreciationRate,
            defaulto: true,
        },
        {
            key: 'status',
            dataKey: 'status',
            title: t`Status`,
            width: 0,
            flexGrow: 12,
            cellRenderer: Helper.renderStatus,
            required: true,
        },
    ];
}

export default {
    storageKey: StorageKey.report_fixed_assets,
    getColumns,
    getReportLabel: () => t`Fixed Asset List`,
};
